export default "__VITE_ASSET__379a93ae__"